import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "@config/api.config";
import { PagedResponse } from "@app/models/paged-response";

@Injectable({
  providedIn: "root",
})
export class GoalsService {
  constructor(private http: HttpClient) {}

  findAll(page: number, size: number, sort?: string, direction?: string): Observable<PagedResponse<any>> {
    let params = new HttpParams().set("page", page).set("size", size);

    if (sort) {
      params = params.set("sort", `${sort},${direction || "asc"}`);
    }

    return this.http.get<PagedResponse<any>>(`${Config.webApiUrl}/v1/goal`, { params });
  }

  findAllByPersonId(userId: string): Observable<any[]> {
    let params = new HttpParams();
    params = params.set("userId", userId.toString());

    return this.http.get<any[]>(`${Config.webApiUrl}/v1/goal/person`, { params });
  }

  findById(id: string): Observable<any> {
    return this.http.get<any>(`${Config.webApiUrl}/v1/goal/${id}`);
  }

  create(goal: any): Observable<any> {
    return this.http.post(`${Config.webApiUrl}/v1/goal`, goal);
  }

  update(id: string, goal: any): Observable<any> {
    return this.http.put(`${Config.webApiUrl}/v1/goal/${id}`, goal);
  }

  delete(goalId: string): Observable<any> {
    return this.http.delete(`${Config.webApiUrl}/v1/goal/${goalId}`);
  }
}
